import Loading from '@/components/Loading'
import useGetCurrentUser from '@/hooks/useGetCurrentUser'
import InitiativeDashboardHomeSkeleton from '@/pages/Initiatives/DashboardHome/Skeleton'
import { useParams } from '@tanstack/react-router'

export default function InitiativeViewPending() {
  const { initiativeId }: { initiativeId?: string } = useParams({
    strict: false,
  })
  const user = useGetCurrentUser()

  if (initiativeId != null && user?.isDashboardOnly(Number(initiativeId))) {
    return <InitiativeDashboardHomeSkeleton />
  }

  return <Loading />
}
